import React, { useCallback, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Card, CardBody } from "reactstrap";
import classnames from "classnames";
import EditSurveyTab from "pages/settings/survey-management/surveyDetails/Tabs/EditSurveyTab";
import { getTabButtons, TABS } from "pages/settings/survey-management/surveyDetails/constants";
import SurveyDetailsTab from "pages/settings/survey-management/surveyDetails/Tabs/SurveyDetailsTab";
import SurveyHistoryTab from "pages/settings/survey-management/surveyDetails/Tabs/SurveyHistoryTab";
import { userHasAdminRole, userHasOneOfRoles } from "utils/helpers/functions";

const useStyles = makeStyles({
  root: {
    width: "100%",
    marginTop: 30,
    display: "flex",
  },
  container: {
    borderRadius: 30,
    width: "100%",
    padding: 30,
  },
  tabs: {
    display: "flex",
    padding: "30px 0",
    fontSize: 13,
    fontWeight: 600,
    flexDirection: "column",
    marginRight: -4,
  },
  tab: {
    backgroundColor: "#E1E1E1",
    padding: 15,
    borderRadius: "10px 0 0 10px",
    marginBottom: 10,
    whiteSpace: "nowrap",

    "&:hover": {
      cursor: "pointer",
    },
  },
  active: {
    backgroundColor: "#FFFFFF!important",
  },
  cardBody: {
    padding: 0,
  },
});

const DataTabs = ({ isCreate, survey, surveyHistory, setIsLoading }) => {
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState(isCreate ? TABS.EDIT_SURVEY : TABS.SURVEY_DETAILS);

  const onTabClick = useCallback(e => {
    const tab = e.target.dataset.tab;
    setActiveTab(tab);
  }, []);

  return (
    <div className={classes.root}>
      <div className={classes.tabs}>
        {getTabButtons(isCreate).map(item => {
          // if (item?.allowCategories && !item.allowCategories.includes(survey.id)) return null;
          if (item?.hideRoles && !userHasAdminRole() && userHasOneOfRoles(item?.hideRoles)) return null;
          return (
            <div
              key={item.key}
              className={classnames(classes.tab, activeTab === item.key && classes.active)}
              data-tab={item.key}
              onClick={onTabClick}
            >
              {item.title}
            </div>
          );
        })}
      </div>
      <Card className={classes.container}>
        <CardBody className={classes.cardBody}>
          {activeTab === TABS.SURVEY_DETAILS && <SurveyDetailsTab survey={survey} />}
          {activeTab === TABS.EDIT_SURVEY && (
            <EditSurveyTab isCreate={isCreate} survey={survey} setIsLoading={setIsLoading} />
          )}
          {activeTab === TABS.SURVEY_HISTORY && <SurveyHistoryTab history={surveyHistory} />}
        </CardBody>
      </Card>
    </div>
  );
};

export default DataTabs;
